import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Consult = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M46.4583 46.4583C45.6529 47.2637 44.3471 47.2637 43.5417 46.4583L39.375 42.2916C38.6111 42.743 37.8125 43.0989 36.9792 43.3593C36.1458 43.6197 35.2778 43.7499 34.375 43.7499C31.7708 43.7499 29.5573 42.8385 27.7344 41.0155C25.9115 39.1926 25 36.9791 25 34.3749C25 31.7708 25.9115 29.5572 27.7344 27.7343C29.5573 25.9114 31.7708 24.9999 34.375 24.9999C36.9792 24.9999 39.1927 25.9114 41.0156 27.7343C42.8385 29.5572 43.75 31.7708 43.75 34.3749C43.75 35.2777 43.6198 36.1458 43.3594 36.9791C43.099 37.8124 42.7431 38.611 42.2917 39.3749L46.4583 43.5416C47.2637 44.347 47.2637 45.6528 46.4583 46.4583ZM34.375 39.5833C35.8333 39.5833 37.066 39.0798 38.0729 38.0728C39.0799 37.0659 39.5833 35.8332 39.5833 34.3749C39.5833 32.9166 39.0799 31.6839 38.0729 30.677C37.066 29.6701 35.8333 29.1666 34.375 29.1666C32.9167 29.1666 31.684 29.6701 30.6771 30.677C29.6701 31.6839 29.1667 32.9166 29.1667 34.3749C29.1667 35.8332 29.6701 37.0659 30.6771 38.0728C31.684 39.0798 32.9167 39.5833 34.375 39.5833ZM43.75 18.7499C43.75 19.9005 42.8173 20.8333 41.6667 20.8333C40.5161 20.8333 39.5833 19.9005 39.5833 18.7499V10.4166H35.4167V15.6666C35.4167 16.2189 34.9689 16.6666 34.4167 16.6666H15.5833C15.031 16.6666 14.5833 16.2189 14.5833 15.6666V10.4166H10.4167V39.5833H18.75C19.9006 39.5833 20.8333 40.516 20.8333 41.6666C20.8333 42.8172 19.9006 43.7499 18.75 43.7499H10.4167C9.27083 43.7499 8.28993 43.3419 7.47396 42.526C6.65799 41.71 6.25 40.7291 6.25 39.5833V10.4166C6.25 9.27075 6.65799 8.28985 7.47396 7.47388C8.28993 6.6579 9.27083 6.24992 10.4167 6.24992H19.1146C19.4965 5.03464 20.2431 4.03638 21.3542 3.25513C22.4653 2.47388 23.6806 2.08325 25 2.08325C26.3889 2.08325 27.6302 2.47388 28.724 3.25513C29.8177 4.03638 30.5556 5.03464 30.9375 6.24992H39.5833C40.7292 6.24992 41.7101 6.6579 42.526 7.47388C43.342 8.28985 43.75 9.27075 43.75 10.4166V18.7499ZM25 10.4166C25.5903 10.4166 26.0851 10.2169 26.4844 9.81763C26.8837 9.41832 27.0833 8.92353 27.0833 8.33325C27.0833 7.74297 26.8837 7.24818 26.4844 6.84888C26.0851 6.44957 25.5903 6.24992 25 6.24992C24.4097 6.24992 23.9149 6.44957 23.5156 6.84888C23.1163 7.24818 22.9167 7.74297 22.9167 8.33325C22.9167 8.92353 23.1163 9.41832 23.5156 9.81763C23.9149 10.2169 24.4097 10.4166 25 10.4166Z"
        fill={color}
      />
    </svg>
  )
}
